import {
    Component,
    ElementRef,
    HostListener,
    OnInit,
    ViewChild,
} from '@angular/core';
import { Size } from '../../services/size';
import { IDateRange } from 'src/app/interfaces/date-range.interface';
import { ServicesService } from 'src/app/services/services.service';
import { LoadService } from 'src/app/services/application/load.service';
import { Title } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { AlertService } from 'src/lib/ariadna/alert';
import moment from 'moment';
import { IService } from 'src/app/interfaces/services';
import { ServicesDetailsDialogComponent } from './dialogs/services-details-dialog/services-details-dialog.component';
import { PayPeriodDialogComponent } from '../payments/dialogs/pay-period-dialog/pay-period-dialog.component';

import {
    getTekDay,
    getNameDay,
    getTime,
    getDayWithYear,
} from '../application/global.function';
import { IPeriod } from 'src/app/interfaces/period.interface';
import { lastValueFrom } from 'rxjs';

@Component({
    selector: 'app-services',
    templateUrl: './services.component.html',
    styleUrls: ['./services.component.scss'],
})
export class ServicesComponent implements OnInit {
    orderUP = true; // С начала последние
    orderUPText: string = 'Сначала последние';
    loadedPages = 1;
    viewPage = 1;
    periodText = '';
    date: IDateRange;
    countOfPages = 1;
    servicesPages: Array<IService[]> = [];
    servicesListLength: number = 0; // Количество записей
    // countRecToPage = 15; // Количетсво записей на странице
    loadingMoreContent = false;
    isLoading = false;
    private _setting: any;

    dtBegin: Date | null = null; // Дата начала
    dtEnd: Date | null = null; // Дата ококнчания
    orderUPTextPC: string = 'Сначала последние';
    page = 1;
    width = 0;
    servicesList: IService[] | null = null;
    countRectoPage: number = 10; // Количетсво записей на странице
    loadingServicesList = false; // Загрузка
    selectedButton: 'today' | '3days' | 'all' | null = 'all';
    pStart: number = 1;
    pEnd: number = 10;
    isMobile: boolean = false;
    mobileMediaQuery: any;

    constructor(
        private ss: ServicesService,
        private size: Size,
        private load: LoadService,
        private title: Title,
        private dialog: MatDialog,
        private alert: AlertService,
    ) {
        this._setting = load.configData.pages.services;
        if (this._setting?.title) {
            this.title.setTitle(this._setting.title);
        }

        this.date = { dt_begin: new Date(), dt_end: new Date() };
    }

    destroyMobileCheck(): void {
        this.mobileMediaQuery.removeEventListener(
            'change',
            this.handleMediaChange,
        );
    }

    ngOnInit(): void {
        moment.locale('ru');
        this.date.dt_begin?.setDate(this.date.dt_begin.getDate() - 31);

        this.isLoading = true;

        try {
            this.formatDateToString(this.date);
            this.initializeMobileCheck();
            this.dtBegin = new Date();
            this.dtBegin.setDate(this.dtBegin.getDate() - 31);
            this.dtEnd = new Date();

            this.width = window.innerWidth;
            this.setPeriodTextPC();

            if (this.isMobile) {
                this.changePeriod({
                    dt_begin: this.date.dt_begin,
                    dt_end: this.date.dt_end,
                });
            } else {
                this.changePeriodPC({ begin: this.dtBegin, end: this.dtEnd });
            }
        } catch (error) {
            console.error('Ошибка при загрузке данных:', error);
            this.alert.error('Не удалось загрузить данные');
            this.isLoading = false;
        } finally {
            setTimeout(() => {
                this.isLoading = false;
            }, 2000);
        }
    }

    /** Подгрузка услуг следующей страницы */
    loadNextPage() {
        if (
            this.loadedPages / this.countOfPages !== 1 &&
            !this.loadingMoreContent &&
            this.countOfPages > 0
        ) {
            this.loadedPages++;
            this.loadMoreServices(
                this.loadedPages * this.countRectoPage -
                    this.countRectoPage +
                    1,
                this.loadedPages * this.countRectoPage,
            );
        }
    }

    private observer!: IntersectionObserver;

    ngAfterViewInit(): void {
        this.initIntersectionObserver();
    }
    initializeMobileCheck(): void {
        // Определяем мобильное устройство по ширине экрана
        this.mobileMediaQuery = window.matchMedia('(max-width: 768px)');
        this.isMobile = this.mobileMediaQuery.matches;

        // Слушаем изменения размеров экрана
        this.mobileMediaQuery.addEventListener(
            'change',
            this.handleMediaChange,
        );
    }

    handleMediaChange = (event: MediaQueryListEvent): void => {
        this.isMobile = event.matches;
    };
    isFirstTrigger: boolean = true;
    private debounceTimer: any;

    private initIntersectionObserver(): void {
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }

        this.debounceTimer = setTimeout(() => {
            if (
                !this.sentinel ||
                !this.sentinel.nativeElement ||
                !this.servicesContainer ||
                !this.servicesContainer.nativeElement
            ) {
                setTimeout(() => this.initIntersectionObserver(), 300);
                return;
            }

            this.observer = new IntersectionObserver(
                (entries) => {
                    const entry = entries[0];

                    if (this.isFirstTrigger) {
                        this.isFirstTrigger = false;
                        return;
                    }

                    if (entry.isIntersecting && this.hasMoreData) {
                        // Check if list is empty
                        if (
                            !this.servicesList ||
                            this.servicesList.length === 0
                        ) {
                            return;
                        }

                        const nextStart = this.pEnd + 1;

                        // Prevent invalid range where start > end
                        if (nextStart > this.servicesListLength) {
                            this.hasMoreData = false;
                            return;
                        }

                        const nextEnd = Math.min(
                            nextStart + this.countRectoPage - 1,
                            this.servicesListLength,
                        );

                        // Additional validation to ensure valid range
                        if (nextStart <= nextEnd) {
                            this.pStart = nextStart;
                            this.pEnd = nextEnd;
                            this.getServicesPC(this.pStart, this.pEnd);
                        } else {
                            this.hasMoreData = false;
                        }
                    }
                },
                {
                    root: this.servicesContainer.nativeElement,
                    threshold: 0.1,
                },
            );
            this.observer.observe(this.sentinel.nativeElement);
        }, 500);
    }
    ngOnDestroy(): void {
        if (this.observer) {
            this.observer.disconnect(); // Отключаем observer
        }
        this.destroyMobileCheck(); // Удаляем слушатель

        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
    }

    trackById(index: number, item: IService): number {
        return item.historyEventsId || index;
    }

    /** Изменение периода для вывода записей*/
    async changePeriod(dt: IDateRange) {
        this.loadingMoreContent = true;
        this.date = dt;
        this.servicesPages = [];
        await this.getServicesSize();
        this.formatDateToString(this.date);
        this.periodText = this.getPeriodText(this.date);
        this.loadedPages = 1;
        this.viewPage = 1;
        this.loadingMoreContent = false;
        setTimeout(() => {
            this.isLoading = false;
        }, 1000);
    }

    /** Получение количества услуг */
    async getServicesSize() {
        try {
            const res = await lastValueFrom(
                this.ss.getServicesSize(this.date.dt_begin, this.date.dt_end),
            );

            if (res.size) {
                this.servicesListLength = res.size;

                if (this.isMobile) {
                    await this.loadMoreServices(1, this.countRectoPage);
                }
                this.setCountOfPages();
            } else {
                this.servicesListLength = 0;
                this.servicesPages = []; // Очищаем список страниц
                this.loadedPages = 1; // Сбрасываем счетчик загруженных страниц
                this.viewPage = 1;
                this.setCountOfPages();
            }
        } catch (error) {
            this.alert.error('Ошибка при загрузке списка услуг');
            this.servicesListLength = 0;
        } finally {
            // setTimeout(() => {
            this.isLoading = false;
            // }, 1000);
        }
    }

    /** Подгрузка дополнительного кал-ва услуг */
    async loadMoreServices(pStart?: number, pEnd?: number) {
        const order = this.orderUP ? 'desc' : 'asc';

        try {
            const res = await lastValueFrom(
                this.ss.getServices(
                    this.date.dt_begin,
                    this.date.dt_end,
                    pStart,
                    pEnd,
                    order,
                ),
            );

            res.forEach((item) => {
                item.dtSort = new Date(
                    item.ps_dat.replace(/(\d+).(\d+).(\d+)/, '$3/$2/$1'),
                );
            });

            if (res) {
                this.servicesPages.push(res);
            }
        } catch (error) {
            this.alert.error('Ошибка при загрузке списка услуг');
        }
    }

    /**
     * Фильтрация записей по дате
     * @param {number | null} startOffset Сдвиг даты С
     * @param {number | null} endOffset Сдвиг даты ПО
     */
    btnFilterByDay(
        startOffset: number | null = 0,
        endOffset: number | null = 0,
    ) {
        if (startOffset !== null && endOffset !== null) {
            this.date.dt_begin = new Date();
            this.date.dt_begin.setDate(
                this.date.dt_begin.getDate() - startOffset,
            );
            this.date.dt_end = new Date();
            this.date.dt_end.setDate(this.date.dt_end.getDate() - endOffset);
            this.changePeriod({
                dt_begin: this.date.dt_begin,
                dt_end: this.date.dt_end,
            });
        } else {
            this.changePeriod({
                dt_begin: new Date(2000, 0, 1),
                dt_end: new Date(),
            });
        }
    }

    /** Получение дня недели */
    getNameDay(dt: Date): string {
        return getNameDay(dt);
    }

    /** Получение времени формата "D MM YYYY" */
    getDayWithYear(dtSort: Date) {
        return getDayWithYear(dtSort);
    }

    /** Получение времени формата "HH:mm" */
    getTime(dt: Date): string {
        return getTime(dt);
    }

    /** Получение периода текстом в формате "D MMM YYYY"*/
    formatDateToString(dt: IDateRange) {
        if (dt.dt_begin) {
            dt.str_begin = moment(new Date(dt.dt_begin)).format('D MMM YYYY');
        }
        if (dt.dt_end) {
            dt.str_end = moment(new Date(dt.dt_end)).format('D MMM YYYY');
        }
    }

    /** Установка количества страниц*/
    setCountOfPages() {
        this.countOfPages = Math.ceil(
            this.servicesListLength / this.countRectoPage,
        );
    }

    /** Вызов диалога для выбора периода */
    showPeriodDialog() {
        const periodDialog = this.dialog.open(PayPeriodDialogComponent, {
            maxWidth: '650px',
            width: '100%',
            height: '100%',
            data: {
                dateRange: {
                    dt_begin: this.date.dt_begin,
                    dt_end: this.date.dt_end,
                } as IDateRange,
            },
        });

        periodDialog.afterClosed().subscribe((result) => {
            if (result?.date) {
                this.pStart = 1;
                this.pEnd = this.countRectoPage;
                this.isLoading = true;
                this.changePeriod(result.date).then(
                    () => (this.isLoading = false),
                );
            }
        });
    }

    /** Вызов диалога с деталями услуги */
    showDetailsDialog(serv: IService) {
        const detailsDialog = this.dialog.open(ServicesDetailsDialogComponent, {
            maxWidth: '100vw',
            maxHeight: '100vh',
            panelClass: 'no-border-radius',
            data: {
                service: serv,
            },
        });

        detailsDialog.afterClosed().subscribe((result) => {});
    }

    /** Полученеи текста из периода */
    getPeriodText(dt: IDateRange) {
        let periodText = '';
        let isSelectedOneDay = dt.str_begin === dt.str_end;

        if (isSelectedOneDay) {
            if (dt.dt_begin == null && dt.dt_end == null)
                periodText = 'Услуги за всё время';
            else if (dt.dt_begin?.toDateString() === new Date().toDateString())
                periodText = 'Последние услуги';
            else if (dt.str_begin) periodText = dt.str_begin;
        } else if (dt.str_begin && dt.str_end) {
            periodText = `${dt.str_begin} - ${dt.str_end}`;
        } else if (dt.str_begin) {
            periodText = dt.str_begin;
        } else if (dt.str_end) {
            periodText = dt.str_end;
        }
        return periodText;
    }

    /******************************************* PC ***********************************/

    changePeriodPC(dt: IPeriod) {
        //
        this.dtBegin = dt.begin;
        this.dtEnd = dt.end;
        this.getServicesSizePC();
        this.setPeriodTextPC();
        if (this.observer) {
            this.initIntersectionObserver();
        }
    }

    // Количество записей
    getServicesSizePC() {
        this.isLoading = true;
        this.loadingServicesList = true;
        this.servicesList = null;
        this.ss.getServicesSize(this.dtBegin, this.dtEnd).subscribe(
            (res) => {
                if (res.size) {
                    this.servicesListLength = res.size;
                    this.getServicesPC(1, this.countRectoPage);
                    this.setCountOfPagesPC();
                    // setTimeout(() => {
                    //     this.isLoading = false;
                    // }, 1000);
                } else {
                    this.servicesListLength = 0;
                    this.loadingServicesList = false;
                    this.isLoading = false;
                }
            },
            (err) => {
                console.error('Error=', err);
                this.loadingServicesList = false;
                this.isLoading = false;
            },
        );
    }

    // TODO: Сделать подгрузку записей при помощи Lazy-loading
    getServicesPC(pStart?: number, pEnd?: number) {
        // Устанавливаем флаг загрузки перед запросом
        this.loadingServicesList = true;
        let order = this.orderUP ? 'desc' : 'asc';
        this.ss
            .getServices(this.dtBegin, this.dtEnd, pStart, pEnd, order)
            .subscribe(
                (res) => {
                    // Обновляем данные
                    if (!this.servicesList || this.servicesList.length === 0) {
                        this.servicesList = res;
                    } else {
                        this.servicesList = [...this.servicesList, ...res];
                    }

                    // Обработка дат
                    this.servicesList.forEach((item) => {
                        item.dtSort = new Date(
                            item.ps_dat.replace(
                                /(\d+).(\d+).(\d+)/,
                                '$3/$2/$1',
                            ),
                        );
                    });

                    // Сбрасываем флаг загрузки
                    this.loadingServicesList = false;

                    // Обновление флага наличия данных
                    this.hasMoreData =
                        this.servicesList.length < this.servicesListLength;

                    //  Обновляем количество страниц
                    this.setCountOfPagesPC();
                    if (this.isLoading) {
                        this.isLoading = false;
                    }
                },
                (err) => {
                    console.error('Error=', err);
                    this.loadingServicesList = false;
                    this.isLoading = false;
                    this.alert.error('Ошибка при загрузке списка услуг');
                },
            );
    }

    // За сегодня
    btnFilterTekPC() {
        this.dtBegin = new Date();
        this.dtEnd = new Date();
        this.selectedButton = 'today';
        // this.selectedButton = this.selectedButton === 'today' ? null : 'today';
        this.customDateSelected = false;
        this.pStart = 1;
        this.pEnd = this.countRectoPage;
        this.changePeriodPC({ begin: this.dtBegin, end: this.dtEnd });
    }

    // За 3 дня
    btnFilter3DayPC() {
        this.dtBegin = new Date();
        this.dtBegin.setDate(this.dtBegin.getDate() - 3);
        this.dtEnd = new Date();
        this.selectedButton = '3days';
        // this.selectedButton = this.selectedButton === '3days' ? null : '3days';
        this.customDateSelected = false;
        this.pStart = 1;
        this.pEnd = this.countRectoPage;
        this.changePeriodPC({ begin: this.dtBegin, end: this.dtEnd });
    }

    btnAllDays() {
        this.selectedButton = 'all';
        // this.selectedButton = this.selectedButton === 'all' ? null : 'all';
        this.dtBegin = new Date(2000, 0, 1);
        this.dtEnd = new Date();
        this.servicesList = [];
        this.pStart = 1;
        this.pEnd = this.countRectoPage;
        this.hasMoreData = true;
        this.loadedPages = 1;
        this.customDateSelected = false;

        this.changePeriodPC({ begin: this.dtBegin, end: this.dtEnd });
    }
    customDateSelected = false;
    onDateRangeChanged(period: IPeriod) {
        // Обновляем начало и конец периода
        this.dtBegin = period.begin;
        this.dtEnd = period.end;
        this.selectedButton = 'all';
        this.customDateSelected = true;
        // Перезагружаем список платежей
        this.changePeriodPC({ begin: this.dtBegin, end: this.dtEnd });
    }

    // С начала последние
    btnFilterOrderUpPC() {
        if (this.servicesList && this.servicesList.length > 0) {
            // Отключаем observer перед сменой порядка
            if (this.observer) {
                this.observer.disconnect();
            }

            // Очищаем список и сбрасываем параметры
            this.servicesList = [];
            this.pStart = 1;
            this.pEnd = this.countRectoPage;
            this.hasMoreData = true;
            this.loadedPages = 1;

            this.orderUP = !this.orderUP;
            this.orderUPText = this.orderUP
                ? 'Сначала последние'
                : 'Сначала первые';

            // Загружаем первую страницу с новым порядком
            this.getServicesPC(this.pStart, this.pEnd);

            // Пересоздаем observer после первой загрузки
            setTimeout(() => {
                this.initIntersectionObserver(); // Только при изменении порядка
            }, 500);
        }
    }

    isBlockYearPC(index: number): boolean {
        let f = false;
        if (
            this.servicesList &&
            this.servicesList[index] &&
            this.servicesList[index - 1]
        ) {
            if (
                this.servicesList[index].dtSort.getFullYear() !==
                this.servicesList[index - 1].dtSort.getFullYear()
            ) {
                f = true;
            }
        }
        if (index === 0) {
            f = true;
        }
        return f;
    }

    getYearPC(index: number): string {
        if (this.servicesList && this.servicesList[index]) {
            return this.servicesList[index].dtSort.getFullYear() + '';
        } else {
            return '';
        }
    }

    getDateTimeFullPC(dt: Date): string {
        let tmp = '';
        //
        moment.locale('ru');
        tmp =
            moment(dt).format('D MMM YYYY') +
            ' в ' +
            moment(dt).format('HH:mm');
        return tmp;
    }

    getTekDayPC(dt: Date): string {
        return getTekDay(dt);
    }

    getNameDayPC(dt: Date): string {
        return getNameDay(dt);
    }

    getTimePC(dt: Date): string {
        return getTime(dt);
    }

    // Получение периода текстом
    setPeriodTextPC() {
        let strBegin = '';
        let strEnd = '';
        if (this.dtBegin) {
            strBegin = moment(new Date(this.dtBegin)).format('D MMM YYYY');
        }
        if (this.dtEnd) {
            strEnd = moment(new Date(this.dtEnd)).format('D MMM YYYY');
        }

        if (strBegin && strEnd) {
            this.periodText = `${strBegin} - ${strEnd}`;
        } else if (strBegin) {
            this.periodText = strBegin;
        } else if (strEnd) {
            this.periodText = strEnd;
        } else {
            this.periodText = 'Последние услуги';
        }
    }

    setCountOfPagesPC() {
        this.countOfPages = Math.ceil(
            this.servicesListLength / this.countRectoPage,
        );
    }
    scrollTimeout: any = null;
    scrollPosition: any;
    @HostListener('window:scroll', ['$event'])
    @ViewChild('sentinel')
    sentinel!: ElementRef;

    @ViewChild('servicesContainer') servicesContainer!: ElementRef;

    currentPage = 1;

    hasMoreData = true; // Флаг наличия следующих данных
}
